export const CONSENT_SLICE_NAME = 'consent';

export const CONSENT_SEND_CONSENT_FROM_LINK_PREFIX: string = `${CONSENT_SLICE_NAME}/sendConsentFromLink`;
export const CONSENT_UPDATE_CONSENT_FROM_LINK_PREFIX: string = `${CONSENT_SLICE_NAME}/updateConsentFromLink`;
